'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import Swimlane from '@/app/[locale]/(worlds)/components/Swimlane';
import { SWIMLANE_SCROLL_BLEED_CLASS } from '@/constants/swimlane';
import { EditorChoiceCards } from '@/services/cms';
type NewPremiumReleasesSectionProps = {
  title?: ReactNode;
  worlds: EditorChoiceCards;
};
export default function NewPremiumReleasesSection(t0) {
  const $ = _c(3);
  const {
    title,
    worlds
  } = t0;
  if (!worlds.rooms || worlds.rooms.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title || $[1] !== worlds) {
    t1 = <Swimlane title={title} world={worlds} cardVariant="viverse" dataRoomIdPrefix="pr" suppressFreshnessBadges={true} hideLiked={true} hidePremiumBadge={false} scrollClassName={`${SWIMLANE_SCROLL_BLEED_CLASS} gap-2 md:gap-4`} scrollContainerClassName="-mx-4 md:-mx-4 lg:-mx-6" />;
    $[0] = title;
    $[1] = worlds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}